export default "__VITE_ASSET__bxxZs5Z3__"